export const SHOW_ERRORMESSAGE_SCREEN =
  "This website builder is available only on large screens for now 😞";
export const SUB_DOMAIN_ERROR =
  "Minimum 6 characters allowed and special characters are not allowed except '-'";
export const CUSTOM_DOMAIN_ERROR =
  "Please enter plain domain name or subdomain name without https:// or http:// or www. and special characters are not allowed.For example : acme.com or subdomain.acme.com";
